import {TokenActionTypes, TokenAction, TokenState} from '../../types/token'
    
    const initialState = {
        tokenData: '',
        inProgress: false,
        error: null,
        authorizedAsan: false,
        mSignStatus: '',
        userData: {},
        notify: false,
        inProgressAsan: false,
        simaQrCode: '',
        simaInProgress: false,
        simaPolling: false,
        simaExpired: false,
        simaError: false,
    }
const tokenReducer = (state = initialState, action: TokenAction) : TokenState => {  
switch (action.type) {
    case TokenActionTypes.GET_TOKEN_DATA_REQUEST:
      return {
        ...state,
        tokenData: '',
        inProgress: true,
        inProgressAsan: true,
      }
    case TokenActionTypes.GET_TOKEN_DATA_SUCCESS:
      return {
        ...state,
        tokenData: action.payload,
        inProgressAsan: false,
      }
      case TokenActionTypes.REMOVE_NOTIFICATION_ASAN:
        return {
          ...state,
          notify: false
        }
    case TokenActionTypes.GET_TOKEN_DATA_ERROR:
      return {
        ...state,
        error: action.error.result.data,
        notify: true,
        inProgressAsan: false,
        
      }
      case TokenActionTypes.GET_AUTHORIZATION_VALUE_REQUEST:
        return {
          ...state,
          authorizedAsan: false,
        }
      case TokenActionTypes.GET_AUTHORIZATION_VALUE_SUCCESS:
        return {
          ...state,
          mSignStatus: action.payload.result.data.mSignStatus,
          userData: action.payload.result.data,
        }
      case TokenActionTypes.GET_AUTHORIZATION_VALUE_ERROR:
        return {
          ...state,
          authorizedAsan: false,
          error: action.error.data,
          notify: true,
        }
        case TokenActionTypes.CANCEL_ASAN_SIGN:
          return {
            ...state,
            mSignStatus: action.payload.result.data.mSignStatus,
            authorizedAsan: true
          }
      case TokenActionTypes.GET_SIMA_DATA_REQUEST:
        return {
          ...state,
          simaInProgress: true,
          simaQrCode: '',
          simaPolling: false,
          simaExpired: false,
          simaError: false,
          error: null,
          notify: false,
        }
      case TokenActionTypes.GET_SIMA_DATA_SUCCESS:
        return {
          ...state,
          simaInProgress: false,
          simaQrCode: action.payload.qrCode,
          simaPolling: true,
        }
      case TokenActionTypes.GET_SIMA_DATA_ERROR:
        return {
          ...state,
          simaInProgress: false,
          simaPolling: false,
          error: action.error,
          notify: true,
        }
      case TokenActionTypes.GET_SIMA_STATUS_REQUEST:
        return { ...state }
      case TokenActionTypes.GET_SIMA_STATUS_SUCCESS:
        return { ...state, simaPolling: false }
      case TokenActionTypes.GET_SIMA_STATUS_ERROR:
        return {
          ...state,
          simaPolling: false,
          simaError: true,
          notify: true,
          error: action.error,
        }
      case TokenActionTypes.SIMA_EXPIRED:
        return { ...state, simaExpired: true, simaPolling: false }
      case TokenActionTypes.SIMA_RESET:
        // Clear the SIMA slice back to a clean initial state. Dispatched when a
        // SIMA screen mounts so a remount (e.g. returning to the SIMA login tab
        // after it expired) never shows the stale expired/error screen.
        return {
          ...state,
          simaQrCode: '',
          simaInProgress: false,
          simaPolling: false,
          simaExpired: false,
          simaError: false,
        }
      default:
        return state;
    }
}
export default tokenReducer